import styled from 'styled-components';

import { Box } from 'components/Box';
import { SearchMenu } from 'components/Search/SearchMenu';

const SearchMenuContainer = styled(Box)`
  @media print {
    display: none;
  }
`;

type Props = {
  height?: string | number;
  onSearch?: () => void;
  searchMode: boolean;
  navSection: 'MAIN' | 'STAFF' | undefined;
  defaultSearchType: DefaultSearchType | undefined;
};

export function LayoutSearchMenu({
  height,
  onSearch,
  searchMode,
  navSection,
  defaultSearchType,
}: Props) {
  const search = () => {
    if (onSearch) onSearch();
  };

  return (
    <SearchMenuContainer height={height}>
      <SearchMenu
        searchMode={searchMode}
        // @ts-expect-error TS(2322): Type '"MAIN" | "STAFF" | undefined' is not assigna... Remove this comment to see the full error message
        navSection={navSection}
        onSearch={search}
        defaultSearchType={defaultSearchType}
        searchFrom="Header Search Bar"
        inPageHeader
        styleVariant="contrast"
        prefixVariant="contrast"
      />
    </SearchMenuContainer>
  );
}
